import { render, staticRenderFns } from "./DeviceStatisticsListTable.vue?vue&type=template&id=22b2c722"
import script from "./DeviceStatisticsListTable.vue?vue&type=script&lang=js"
export * from "./DeviceStatisticsListTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports